<p>reset-password works!</p>
<div class="forgot_password_component">
    <div class="page-title-area">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="page-title-text">
                        <h2>Reset Password</h2>
                        <ul>
                            <li><a routerLink="/">Home</a></li>
                            <li><i class="icofont-simple-right"></i></li>
                            <li>Reset-password</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="contact-form-area ptb-100">
        <div class="container-fluid">
            <form
                [formGroup]="resetPassword"
                (ngSubmit)="submit()"
                id="contactForm"
            >
                <div class="row contact-wrap">
                    <div class="col-md-10 col-lg-10 mt-5 forgot_password">
                        <h1>Reset password</h1>


                        <div class="form-group mt-5">
                            <div class="form-group">
                                <label>Current Password</label>
                                <div class="input-group">
                                    <input
                                        [type]="
                                            currentPassword ? 'text' : 'password'
                                        "
                                        class="form-control"
                                        placeholder="*************"
                                        formControlName="oldPassword"
                                    />
                                    <div class="input-group-append">
                                        <button
                                            class="btn btn-outline-secondary"
                                            type="button"
                                            (click)="showCurrentPassFn()"
                                        >
                                            <i
                                                class="fa fa-eye p-3"
                                                [ngClass]="{
                                                    'fa-eye': currentPassword,
                                                    'fa-eye-slash':
                                                        !currentPassword
                                                }"
                                            ></i>
                                        </button>
                                    </div>
                                </div>
                                <app-validation-error
                                [control]="resetPassword.get('oldPassword')"
                            ></app-validation-error>
                            </div>
                        </div>


                        <div class="form-group mt-5">
                            <div class="form-group">
                                <label>New Password</label>
                                <div class="input-group">
                                    <input
                                        [type]="
                                            showPassword ? 'text' : 'password'
                                        "
                                        class="form-control"
                                        placeholder="*************"
                                        formControlName="newPassword"
                                    />
                                    <div class="input-group-append">
                                        <button
                                            class="btn btn-outline-secondary"
                                            type="button"
                                            (click)="showPasswordFn()"
                                        >
                                            <i
                                                class="fa fa-eye p-3"
                                                [ngClass]="{
                                                    'fa-eye': showPassword,
                                                    'fa-eye-slash':
                                                        !showPassword
                                                }"
                                            ></i>
                                        </button>
                                    </div>
                                </div>
                                <app-validation-error
                                [control]="resetPassword.get('newPassword')"
                            ></app-validation-error>
                            </div>
                        </div>

                        <div class="form-group mt-5">
                            <div class="form-group">
                                <label>Confirm Password</label>
                                <div class="input-group">
                                    <input
                                        [type]="
                                            showConfirmPassword
                                                ? 'text'
                                                : 'newPassword'
                                        "
                                        class="form-control"
                                        placeholder="*************"
                                        formControlName="confirmPassword"
                                    />
                                    <div class="input-group-append">
                                        <button
                                            class="btn btn-outline-secondary"
                                            type="button"
                                            (click)="showConfirmPasswordFn()"
                                        >
                                            <i
                                                class="fa fa-eye p-3"
                                                [ngClass]="{
                                                    'fa-eye':
                                                        showConfirmPassword,
                                                    'fa-eye-slash':
                                                        !showConfirmPassword
                                                }"
                                            ></i>
                                        </button>
                                    </div>
                                </div>
                                <app-validation-error
                                [control]="resetPassword.get('confirmPassword')"
                            ></app-validation-error>
                            <span *ngIf="message" class="text-danger password_match">{{ message }}</span>
                            </div>

                        </div>
                    </div>
                    <div class="col-md-8 col-lg-8">
                        <div class="text-center">
                            <button type="submit" class="btn contact-btn">
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
